import React from "react";
import { withStyles } from "@mui/styles";
import { Box, Tabs, Tab } from "@mui/material";
import { theme } from "../../SosTheme.js";

const StyledTabs = withStyles({
  root: {
    borderBottom: "1px solid #333333",
    width: "100%",
  },
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    height: "4px",
    "& > div": {
      maxWidth: 70,
      width: "100%",
      backgroundColor: "#598ced",
    },
  },
})(Tabs);

export function AntTabs(props) {
  return <StyledTabs {...props} TabIndicatorProps={{ children: <div /> }} />;
}

const StyledTab = withStyles({
  root: {
    textTransform: "none",
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    fontFamily: ["futura-pt, sans-serif"].join(","),
    "&:hover": {
      color: "#598ced",
      opacity: 1,
    },
    "&$selected": {
      color: "#598ced",
      fontWeight: theme.typography.fontWeightMedium,
    },
    "&:focus": {
      color: "#598ced",
    },
  },
  selected: {},
})(Tab);

export function AntTab(props) {
  return <StyledTab disableRipple {...props} />;
}

export function TabStrip(props) {
  const { value, handleChange, hasOtherTab } = props;
  return (
    <Box id="hey" style={{ width: "100%" }}>
      <div style={{ width: "66%" }}>
        <div>
          <AntTabs
            value={value}
            onChange={handleChange}
            aria-label="ant example"
            variant="fullWidth"
            style={{ minWidth: "20rem" }}
          >
            <AntTab label="Object" component="a" />
            <AntTab label="Create" component="a" />
            <AntTab label="Query" component="a" />
            <AntTab label="Read" component="a" />
            <AntTab label="Update" component="a" />
            <AntTab label="Delete" component="a" />
            {hasOtherTab && <AntTab label="Other" component="a" />}
          </AntTabs>
        </div>
      </div>
    </Box>
  );
}
